import React, { useContext } from 'react'
import './JobOnboarding.css';
import BigBanner from '../../assets/images/banner-big.png';
import Congratulation from '../../assets/images/Congratulation.png';
import Button from "../../components/Button/Button";
import MultiStepFormContext from "./MultiStepFormContext";
import { useNavigate } from "react-router-dom";


const SuccessPage = () =>
{
    const { details, timeBudget } = useContext(MultiStepFormContext);
    const navigate = useNavigate();

    const redirectToPage = () =>
    {
        navigate("/JobsDashboard");
    }


    return (
        <div>
            <div className="left_panel">
                <div className="left_panel-div1">
                    <img src={BigBanner} alt="Banner" className='banner-image-img' />
                </div>
                <div className="left_panel-div2 d-flex flex-column justify-content-center align-items-center">
                    <img className='mb-1' src={Congratulation} alt='Congo' />
                    <div className='mb-5'>

                        <p className="left_panel-div2-P">CONGRATULATIONS test!</p>
                        <p className="left_panel-div2-P mb-4">YOUR JOB HAS BEEN POSTED!</p>
                        <p className="subtitle-p mb-4">
                            Relevant tradies are being contacted and you will soon receive message and or notifications
                        </p>
                        <p className="text-wrapper-p ">JOB DETAILS</p>
                        <div className='description-box-p'>
                            <p className="text-wrapper-p">Postcode:&nbsp;&nbsp;&nbsp;&nbsp;</p>
                            <span className="span-p">{details?.postcode}</span>
                        </div>
                        <div className='description-box-p'>
                            <p className="text-wrapper-p">Description:&nbsp;&nbsp;</p>
                            <p className="span-p"
                            >{details?.description} </p>
                        </div>
                        <div className='d-flex justify-content-around'>
                            <div className='description-box-p'>
                                <p className="text-wrapper-p">Budget:&nbsp;&nbsp;</p>
                                <p className="span-p">{timeBudget?.budget}</p>
                            </div>
                            <div className='description-box-p'>
                                <p className="text-wrapper-p">Time:&nbsp;&nbsp;</p>
                                <p className="span-p">{timeBudget?.deadline}</p>
                            </div>
                            <div className='description-box-p'>
                                <p className="text-wrapper-p">Site Visits:&nbsp;&nbsp;</p>
                                <p className="span-p">{timeBudget?.siteVisit}</p>
                            </div>
                        </div>


                    </div>
                    <Button onClick={redirectToPage} title="Finished" />


                </div>
            </div>
        </div>
    )
}

export default SuccessPage
